import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Constants } from '../app.constants';
import { StorageService } from '../app.storage.service';
import { AppService } from '../app.service';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs'
import { CommonService } from '../common.service';


declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router,
    private storageService: StorageService,
    private appService: AppService,
    private commonService : CommonService,
    private changeRef: ChangeDetectorRef) {
    window['homeCompRef'] = { comp: this }
  }

  isFeedbackOpen: boolean = false;
  feedbackTypeList: any[] = Constants.FEEDBACK_TYPE_LIST;
  selectedFeedbackType: any = this.feedbackTypeList[0];
  feedbackDescription: string = null;
  selectedFileForFeedback: any = null;
  userName: string = null;

  peopleText: string = this.appService.getLable(Constants.LABEL_MAP.PEOPLE);
  clientText: string = this.appService.getLable(Constants.LABEL_MAP.CLIENT);
  reportText: string = this.appService.getLable(Constants.LABEL_MAP.REPORTS);
  dashboardText: string = this.appService.getLable(Constants.LABEL_MAP.DASHBOARD_TASK);
  manageText: string = this.appService.getLable(Constants.LABEL_MAP.MANAGE);

  documentSubscription: Subscription;
  imageListSubscription: Subscription;
  imageExtensionList: any[] = Constants.IMAGE_EXTENTION_LIST;
  downloadUrl: string = Constants.DOWNLOAD_URL;
  imageViewUrl: string = Constants.IMAGE_BASE_URL;

  docList: any[] = [];
  imageList: any[] = [];

  profilePic: string = null;
  profilePicObj: any = null;
  docHeadingText: string = "Documents";
  imageHeadingText: string = "Images";

  formDataSubscription: Subscription;
  userData: any = null;
  selectedFileForProfile: any = null;
  managerInfo: any = null;
  userTypeMap = Constants.USER_TYPE;
  navigationPage: string  = null;
  navigationPageSubscription: Subscription;
  attendanceFeatureFlag:boolean;
  filteredData: { count: number, filteredList: any[] } = { count: 0, filteredList: [] };
  customFieldFilterObject: any = {};
  newAccountSubscription: Subscription;
    searchStatus: any = null;
    authToken : any;
  
  ngOnInit(): void {
   
   //console.log(this.userAccountList)
    this.attendanceFeatureFlag = this.appService.isFeature(Constants.FEATURE_MAP.ATTENDANCE_LEAVE_MANAGEMENT);
    this.navigationPageSubscription = this.appService.workmateAppLinkSubject.subscribe((data)=>{
      if(data){
        this.navigationPage = data;
      }
    })
    // this.navigationPage = this.storageService.getDataFromLocalStorage("navigationPage");
    var userData = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.USER_INFO);
   if(userData && userData.accessToken){
    this.authToken = userData.accessToken
   }
    
    this.loadScripts();
   // console.log(userData)
    this.userData = userData;
    this.userName = userData.name;

    var managerInfo = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.MANAGER_INFO);

    // console.log(managerInfo)
    if (managerInfo) {
      this.managerInfo = managerInfo;
    }
    this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.NEW_ACCOUNT,null);
    
    this.getUserAccounts();
    this.preProcessUserAccount();
    this.getProfilePicture();
    this.documentSubscription = this.appService.documentListSubject.subscribe((data) => {
      // console.log(data);
      if (data && data.docs && data.docs.length > 0) {
        if (data.info && data.info.headingName) {
          this.docHeadingText = data.info.headingName;
        } else {
          this.docHeadingText = "Documents";
        }
        this.setDocumentListData(data.docs);
      }

    });

    this.imageListSubscription = this.appService.imageListSubject.subscribe((data) => {
      // console.log(data);
      if (data && data.docs && data.docs.length > 0) {
        if (data.info && data.info.headingName) {
          this.imageHeadingText = data.info.headingName;
        } else {
          this.imageHeadingText = "Images";
        }
        this.setImageListData(data.docs);
      }

    })


    this.formDataSubscription = this.appService.formDataRendererSubject.subscribe((formData) => {
      // console.log(formData)
      if (formData) {
        this.renderFormData(formData);
        this.changeRef.detectChanges();

      }

    })

    // this.setDocumentListData();
    // this.setImageListData();
    this.getUserActivtyForms();
    //let switchUserId = this.storageService.getDataFromLocalStorage("switchUserId");
    this.newAccountSubscription = this.appService.newAccountSubject.subscribe((data) => {
    //  console.log(data)
      if(data && data.newAccount){
        // $('#switchAccModal').modal('show');
        // this.getUserAccounts();
        this.switchAccount();
      }
    
    }
    )
    // let isCreatedNewAccount = this.storageService.getDataFromLocalStorage("isCreatedNewAccount");
    // if(isCreatedNewAccount){
    //   $('#switchAccModal').modal('show');
    //   this.getUserAccounts();
    // }
   

  }

  async getUserActivtyForms() {

    var res: HttpResponse<any> = await this.appService.getActivitiesList();
    var types = res.body.types;
    // console.log(types);
    var typeList = [];
    for(let type of types){
      typeList.push(type.id)
    }

    this.appService.getUserActivityForms(typeList)
      .subscribe((res: HttpResponse<any>) => {
        // let data = res.body.userActivityForms;
        // if(data){
        //   let actTypeList = Constants.FORM_ACTIVTY_TYPE;
        //   let formObj = {};
        //   for(let form of data){
        //     for(let actType of actTypeList){
        //       if(form.isAssigned && form.activityTypes && form.activityTypes.includes(actType)){
        //         let list = formObj[actType];
        //         if(list){
        //           list.push(form);
        //           formObj[actType] = list;
        //         }else{
        //           let list = [];
        //           list.push(form);
        //           formObj[actType] = list;
        //         }
        //       }
        //     }
        //   }

        //   this.appService.userActivityFormSubject.next(formObj);
        // }
      }, (err) => {

      })
  }

  getCustomFormActivity() {
    // this.appService
  }

  ngAfterContentInit() {
    $('#updateLink').click(function () {
      $('#filterUpdate').fadeIn();
    });
    $('.filterClose').click(function () {
      $('#filterUpdate').fadeOut();
    });
  }

  ngOnDestroy() {
    if (this.documentSubscription) {
      this.documentSubscription.unsubscribe();
    }
    if (this.imageListSubscription) {
      this.imageListSubscription.unsubscribe();
    }
    if (this.formDataSubscription) {
      this.formDataSubscription.unsubscribe();
    }
    if(this.navigationPageSubscription){
      this.navigationPageSubscription.unsubscribe();
    }
    if(this.newAccountSubscription){
      this.newAccountSubscription.unsubscribe();
    }
  }

  getProfilePicture() {
    this.appService.getProfilePicture()
      .subscribe((res: HttpResponse<any>) => {
        this.profilePic = null;
        if (res.body.profilePicture && res.body.profilePicture.docId) {
          this.profilePicObj = res.body.profilePicture;
          this.profilePic = res.body.profilePicture.docId;
        }
      }, (err) => {

      })
  }

  removeProfilePic() {
    if (this.profilePic) {
      var message = "Are you sure you want to delete this picture?";
      var title = "Message"
      this.appService.showConfirmationPopup(title, message).then((result) => {
        if (result.value) {
          this.appService.deleteDocument(this.profilePic)
            .subscribe((res: HttpResponse<any>) => {
              this.appService.showSuccessPopup("Success", "Profile Picture removed successfully.");
              this.getProfilePicture();
            }, (err) => {

            })
        }
      })
    }
  }

  pickProfilePic() {
    $("#profile_file").trigger("click");
  }

  logout() {
    this.storageService.clearStorage();
    // this.router.navigate(['login']);
    window.location.href = Constants.LOGIN_URL;
  }

  openFeedbackPanel() {
    this.isFeedbackOpen = true;
    $(".bg-overlay").show();
  }

  closeFeedbackPanel() {
    this.selectedFeedbackType = this.feedbackTypeList[0];
    this.feedbackDescription = null;
    this.selectedFileForFeedback = null;
    this.isFeedbackOpen = false;
    $(".bg-overlay").hide();
  }

  onFileClick() {
    $("#feedback_file").trigger("click");
  }

  onFileSelect() {
    var maxSize = 6 * 1024 * 1024;

    let file = $("#profile_file").prop("files")[0];
    if (file.size < maxSize) {
      var fileName = file.name;
      var ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
      if (["jpg", "jpeg", "png", "gif"].includes(ext.toLowerCase())) {
        var message = "Are you sure you want to upload this picture?";
        var title = "Message"
        this.appService.showConfirmationPopup(title, message).then((result) => {
          if (result.value) {
            this.appService.uploadProfilePicture(file)
              .subscribe((res: HttpResponse<any>) => {
                this.appService.showSuccessPopup("Success", "Profile picture updated successfully.");

                this.getProfilePicture();
                $('.filterClose').trigger('click');
                $("#profileViewModal").modal("hide");
              }, (error) => {
                this.appService.showErrorPopup("Error", "Somethig went wrong.");
                $('.filterClose').trigger('click');
                $("#profileViewModal").modal("hide");
              })
          }
        })

      } else {
        this.appService.showInfoPopup("Info", "File extention is not valid.");
        return;
      }
    } else {
      this.appService.showInfoPopup("Info", "6 MB files in size are allowed only.");
      return;
    }
  }




  submitFeedback() {
    if (!this.selectedFeedbackType) {
      alert("Please select feedback type.");
      return;
    }

    if (!this.feedbackDescription) {
      alert("Description can not be left empty.");
      return;
    }

    this.appService.submitFeedback(this.selectedFeedbackType.str,
      this.feedbackDescription, this.selectedFileForFeedback)
      .subscribe((res: HttpResponse<any>) => {
        // console.log(res.body);
        let data = res.body;
        if (data.outpostResponse == 200) {
          alert("Feedback submitted successfully.");
          this.closeFeedbackPanel();
        } else {
          alert("Something went wrong.");
          this.closeFeedbackPanel();
        }
      }, (error) => {

      })


  }

  viewProfilePic() {
    if (this.profilePicObj) {
      $("#profileViewModal").modal("hide");
      let doc = [];
      doc.push(this.profilePicObj);
      this.appService.imageListSubject.next({ docs: doc, info: { headingName: "Profile Picture" } });
    }
  }



  setDocumentListData(docList?) {
    let docList1 = [{
      checkinId: null,
      claimId: null,
      creationTime: 1585827211,
      docId: "871827c3-0987-4d4c-aca7-a4b3d7d14458",
      docName: "4FFF5798-6166-4AF2-8FE9-068417A339C5.pdf",
      docSize: null,
      docType: null,
      id: 77210,
      partnerId: null,
      taskId: null,
      type: null,
      userId: null,
      workStartId: 146560
    }];

    this.docList = [];
    if (docList && docList.length > 0) {
      for (let doc of docList) {
        let docName = doc.docName;
        let ext = docName.substring(docName.lastIndexOf('.') + 1, docName.length);
        if (!this.imageExtensionList.includes(ext.toLowerCase())) {
          this.docList.push(doc);
        }
      }
    }

    if (this.docList && this.docList.length > 0) {
      $("#docModal").modal("show");
    }
  }

  flag = false;
  setImageListData(imageList?) {
    let imageList1 = [{
      creationTime: 1539066658,
      docId: "ee6234f8-6b03-4dbb-ab59-ea08c9b70de1",
      docName: "7AF1444E-7792-4114-9578-7140570181B8.jpg"
    },
    {
      creationTime: 1539066658,
      docId: "871827c3-0987-4d4c-aca7-a4b3d7d14458",
      docName: "7AF1444E-7792-4114-9578-7140570181B8.jpg"
    }
    ];

    this.imageList = [];
    if (imageList && imageList.length > 0) {
      for (let image of imageList) {
        let imageName = image.docName;
        let ext = imageName.substring(imageName.lastIndexOf('.') + 1, imageName.length);
        if (this.imageExtensionList.includes(ext.toLowerCase())) {
          this.imageList.push(image);
        }
      }
    }
    if (this.imageList && this.imageList.length > 0) {
      $("#thumbModal").modal("show");
      // if(this.thumbsCarousel){
      //   this.thumbsCarousel.trigger("destroy.owl.carousel");
      // this.bigImageCarousel.trigger("destroy.owl.carousel");
      // }

      // this.setCarousel();
      if (!this.flag) {
        // this.setCarousel();
        setTimeout(() => {
          this.setCarousel();
        }, 200)
        this.flag = true;
      } else {

        //  setTimeout(()=>{
        //   var bigimage = $("#big");
        //   var thumbs = $("#thumbs");

        //   bigimage.owlCarousel('refresh.owl.carousel');
        //   thumbs.owlCarousel('refresh.owl.carousel');
        // }, 200)

      }


    }
  }

  bigImageCarousel = null;
  thumbsCarousel = null;
  setCarousel() {
    let that = this;
    $(document).ready(function () {


      var bigimage = $("#big");
      var thumbs = $("#thumbs");
      //var totalslides = 10;
      var syncedSecondary = true;

      that.bigImageCarousel = bigimage
        .owlCarousel({
          items: 1,
          slideSpeed: 2000,
          nav: true,
          autoplay: false,
          dots: false,
          loop: true,
          responsiveRefreshRate: 200,
          navText: [
            '<i class="material-icons">keyboard_arrow_left</i>',
            '<i class="material-icons">keyboard_arrow_right</i>'
          ]
        })
        .on("changed.owl.carousel", syncPosition);

      that.thumbsCarousel = thumbs
        .on("initialized.owl.carousel", function () {
          thumbs
            .find(".owl-item")
            .eq(0)
            .addClass("current");
        })
        .owlCarousel({
          items: 8,
          dots: false,
          nav: false,
          navText: [
            '<i class="material-icons">keyboard_arrow_left</i>',
            '<i class="material-icons">keyboard_arrow_right</i>'
          ],
          smartSpeed: 200,
          slideSpeed: 500,
          slideBy: 8,
          responsiveRefreshRate: 100,
          responsive: {
            0: {
              items: 4
            },
            600: {
              items: 4
            },
            1000: {
              items: 8
            }
          }
        })
        .on("changed.owl.carousel", syncPosition2);

      function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
          current = count;
        }
        if (current > count) {
          current = 0;
        }
        // console.log("currentImage == " + el.item.index);
        //to this
        thumbs
          .find(".owl-item")
          .removeClass("current")
          .eq(current)
          .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
          .find(".owl-item.active")
          .first()
          .index();
        var end = thumbs
          .find(".owl-item.active")
          .last()
          .index();

        if (current > end) {
          thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
          thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
      }

      function syncPosition2(el) {
        if (syncedSecondary) {
          var number = el.item.index;
          bigimage.data("owl.carousel").to(number, 100, true);
        }
      }

      thumbs.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
      });



    });
  }

  hello() {
    var c = $("#big").find(".item.active").prop("index")
    // console.log(c)
  }


  formName: string = null;
  renderFormData(formData) {
    this.formName = formData.formName;

    let data = formData.formData;
    // let data = '[{"label":"Order Details","required":false,"type":"header","value":"Order Details"},{"label":"Select the product Name","required":true,"type":"select","value":"VT12","values":[{"label":"VT12","selected":false,"value":"option-1"},{"label":"X1 Tracker","selected":false,"value":"option-2"},{"label":"X1 Connect","selected":false,"value":"option-3"},{"label":"VT15","selected":false,"value":""},{"label":"Mtrack","selected":false,"value":""},{"label":"CANIQ","selected":true,"value":""}]},{"label":"Customer Information","required":false,"type":"header","value":"Customer Information"},{"label":"Customer Name","maxlength":30,"placeholder":"Enter the Customer Name","required":false,"type":"text","value":""},{"label":"Enter the contact Numebr","max":9999999999,"min":1000000000,"required":false,"type":"number","value":""}]';


    var formData2 = JSON.parse(data);
    for (let obj of formData2) {
      if (obj.type == "select" || obj.type == "autocomplete") {
        if (obj.value != undefined && obj.value != null && obj.values && obj.values.length > 0) {
          for (let option of obj.values) {
            if (option.label == obj.value) {
              option.selected = true;
            } else {
              option.selected = false;
            }
          }
        }
      }
    }

    jQuery(function ($) {
      var fbRender = document.getElementById('fb-render'),
        formData = formData2;

      var formRenderOpts = {
        formData

      };

      $(fbRender).formRender(formRenderOpts);
      $("#fb-render *").attr("disabled", true);
    });


    $("#orderModal").modal("show");


  }
  accountCreation(){
    $('.close-btn').trigger('click');
    this.storageService.setDataInLocalStorage(Constants.STORAGE_KEY.NEW_ACCOUNT,true);
    this.router.navigate(['account']);
  }
  userAccountList : any [] = [];
  
  getUserAccounts(){
    let switchUserId = this.storageService.getDataFromLocalStorage("switchUserId");
    if(switchUserId){
      this.customFieldFilterObject['userId'] = switchUserId;
    }
    // else{
    //   this.customFieldFilterObject['default'] = true;
    // }
    
    
    this.appService.getUserAccounts().subscribe((res:HttpResponse<any>)=>{

      console.log(res.body.accounts);
      this.userAccountList = res.body.accounts;
      if(this.userAccountList && this.userAccountList.length>0){
        // var date = new Date();
        // var time = date.getTime() / 1000;
       
        // for(let userAccount of this.userAccountList){
       
        //   userAccount['isActive'] = false;
        //   if(userAccount.expireDate){
        //     let expiryTime = userAccount.expireDate;
        //     var timeDiff = expiryTime - time;
            
        //     if(timeDiff > 0){
        //       userAccount['isActive'] = true;
        //     }
        //     userAccount['shortName'] =  userAccount.name? this.commonService.nameSorting(userAccount.name) :'';
            
        //   }
         
        // }
        this.preProcessUserAccount();
        console.log(this.userAccountList)
      }
    },(error)=>{
      this.appService.showErrorPopup("Message","Something went wrong")
    })
  }
  makeDefaultAccount(userAccount){
    if(userAccount){
      var accountId = userAccount.id;
      this.appService.makeDefaultAccount(accountId).subscribe((res: HttpResponse<any>)=>{
        console.log(res.body)
        var message = res.body.message;
        this.appService.showSuccessPopup("Message",message);
        this.storageService.setDataInLocalStorage("defaultAccountId",accountId);
        this.preProcessUserAccount();
        // for(let userAccount of this.userAccountList){
        //   if(userAccount.id==accountId && !userAccount.default){
        //     userAccount.default = true;
        //   }else{
        //     userAccount.default = false;
        //   }
        // }
        //this.getUserAccounts();
        
      },(error)=>{
        this.appService.showErrorPopup("Message","Something went wrong")
      })
    
    }
  }
  preProcessUserAccount(){
    let accountId = this.storageService.getDataFromLocalStorage("defaultAccountId");
    var date = new Date();
    var time = date.getTime() / 1000;
   
      for(let userAccount of this.userAccountList){
        if(userAccount.userId == this.userData.id){
          this.selectedAccount = userAccount;
        }
        if (accountId) {
          if (userAccount.id == accountId && !userAccount.default) {
            userAccount.default = true;
          } else {
            userAccount.default = false;
          }
        }
        userAccount['isActive'] = false;
        if (userAccount.expireDate) {
          let expiryTime = userAccount.expireDate;
          var timeDiff = expiryTime - time;

          if (timeDiff > 0) {
            userAccount['isActive'] = true;
          }
          userAccount['shortName'] = userAccount.name ? this.commonService.nameSorting(userAccount.name) : '';

        }
      }
  
   
  }
  selectedAccount : any;
  openAccount(userAccount){
   
    // if(userAccount && userAccount.default){

    // }
    this.appService.newAccountSubject.next(null);
    this.storageService.setDataInLocalStorage("switchUserId",null);
    let userId = userAccount.userId;
    let access_token = this.storageService.getDataFromLocalStorage("getStartedAccessToken");
    this.storageService.clearStorage();
    let fragment = "access_token=" +access_token + "&userId=" + userId;
  
    window.location.href = Constants.WEBAPP_URL+ "landing#" +fragment;
    location.reload();
    $('.close-btn').trigger('click');

  }
  switchAccount(){
    this.getUserAccounts();
    $('#switchAccModal').modal('show');
  }
  // changeAccount(userAccount){
  //   this.selectedAccount = userAccount;
  //   this.openAccount(userAccount);
  // }
  loadScripts() {
    let url = window.location.href;
    console.log(url)
    let script ="";
    if (url.includes("mappls")) {
      script =  'https://apis.mappls.com/advancedmaps/api/'+this.authToken+'/map_sdk_plugins'
    }
    else{
       script =  'https://apis.mapmyindia.com/advancedmaps/api/'+this.authToken+'/map_sdk_plugins'
    }
    const dynamicScripts = [
      script
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
